module.exports = __webpack_public_path__ + "static/media/297473.3bd33ce3.png";